import React, { useState } from 'react';
import { Loader2, Crown } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMPTY = { name: '', email: '', phone: '', company: '', note: '' };

const WaitlistModal = ({ open, onOpenChange }) => {
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async () => {
    if (!form.name.trim() || !form.email.trim() || !form.phone.trim()) {
      return toast.error('Preencha nome, e-mail e telefone.');
    }
    setSaving(true);
    try {
      await axios.post(`${API}/bimmap/waitlist`, form);
      toast.success('Pronto! Você está na lista de espera do Plano Premium. 🎉 Avisaremos assim que abrir.');
      setForm(EMPTY);
      onOpenChange(false);
    } catch {
      toast.error('Erro ao enviar. Tente novamente.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-zinc-900 border-zinc-700 text-white max-w-md" data-testid="bimmap-waitlist-modal">
        <DialogHeader>
          <DialogTitle className="text-2xl flex items-center gap-2"><Crown className="text-red-500" size={22} /> Lista de espera Premium</DialogTitle>
          <DialogDescription className="text-sm text-gray-400">
            Deixe seus dados e avisamos assim que o Plano Premium do BIMMap for lançado — <strong className="text-white">R$ 79,00/ano</strong>, à vista ou em até 12x.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3 py-2">
          <div>
            <label className="text-xs text-gray-400 mb-1.5 block">Nome *</label>
            <Input value={form.name} onChange={(e) => set('name', e.target.value)} className="bg-zinc-800 border-zinc-600" data-testid="bimmap-waitlist-name" />
          </div>
          <div>
            <label className="text-xs text-gray-400 mb-1.5 block">E-mail *</label>
            <Input type="email" value={form.email} onChange={(e) => set('email', e.target.value)} className="bg-zinc-800 border-zinc-600" data-testid="bimmap-waitlist-email" />
          </div>
          <div>
            <label className="text-xs text-gray-400 mb-1.5 block">Telefone / WhatsApp *</label>
            <Input value={form.phone} onChange={(e) => set('phone', e.target.value)} className="bg-zinc-800 border-zinc-600" data-testid="bimmap-waitlist-phone" />
          </div>
          <div>
            <label className="text-xs text-gray-400 mb-1.5 block">Empresa (opcional)</label>
            <Input value={form.company} onChange={(e) => set('company', e.target.value)} className="bg-zinc-800 border-zinc-600" data-testid="bimmap-waitlist-company" />
          </div>
          <div>
            <label className="text-xs text-gray-400 mb-1.5 block">Mensagem (opcional)</label>
            <Textarea value={form.note} onChange={(e) => set('note', e.target.value)} placeholder="Conte o que você espera do Premium" className="bg-zinc-800 border-zinc-600 min-h-[70px]" data-testid="bimmap-waitlist-note" />
          </div>
          <Button onClick={submit} disabled={saving} className="w-full bg-red-600 hover:bg-red-700 text-white h-11" data-testid="bimmap-waitlist-submit">
            {saving ? <Loader2 className="animate-spin mr-2" size={16} /> : null}
            Entrar na lista de espera
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default WaitlistModal;
